<template>
    <div class="flex items-center group/rule">
        <div @click="edit" class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-purple-100 text-purple-800 cursor-pointer hover:border-purple-700 border">
            <filter-text-hint :rule="rule"></filter-text-hint>
        </div>
        <div @click="remove" class="invisible cursor-pointer group-hover/rule:visible">
            <XCircleIcon class="'text-purple-400 hover:text-purple-500 mr-4 flex-shrink-0 h-4 w-4" aria-hidden="true" />
        </div>
    </div>
</template>

<script>

import ModalCondition from "./ModalCondition.vue";
import FilterTextHint from "./filters/FilterTextHint.vue";
import { XCircleIcon } from '@heroicons/vue/24/outline'
import {mapActions} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    components: {
        ModalCondition,
        FilterTextHint,
        XCircleIcon
    },

    props: {
        rule: {
            required: true
        },
        destinationId: {
            required: true
        },
        ruleId: {
            required: true
        },
    },

    data() {
        return {
            openConditionModal: false,
            currentRule: this.rule,
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['deleteDestinationRule']),
        edit() {
            this.emitter.emit("toggle-qr-condition-modal", {
                destinationId: this.destinationId,
                ruleId: this.ruleId,
                rule: this.rule
            });
        },

        remove() {
            this.deleteDestinationRule(this.destinationId, this.ruleId)
        }
    }
}
</script>
